
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    ActionMenu: () => import("@/modules/Documents/components/ActionMenu.vue"),
  },
})
export default class NbTableActions extends Vue {
  isOpen = false;

  toggleOpen(e: MouseEvent) {
    if (e) e.stopPropagation();

    this.isOpen = !this.isOpen;
  }
}
